import styled from 'styled-components';
export const MetaNavigationListItem = styled.li `
  cursor: pointer;
  transform: translateX(-0.5rem);

  &&& > a {
    min-width: unset;
  }

  &&& > button {
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    min-width: unset;
  }

  @media ${({ theme }) => theme.device.medium} {
    transform: none;
  }
`;
